export const LADE_AUSWAHLWERTE_EINSTELLUNGEN = "ladeAuswahlwerteEinstellungen";